const LEGACY_DEFENCE_LABEL = { normal: 'AC', touch: 'touch AC', flat: 'flat-footed AC' };
/** An attack stored without its ruling: a d20, a natural 20 hits and a 1 misses, criticals confirmed by a second roll, at least 1 damage. */
export function legacyAttackRuling(defence) {
    return {
        dice: { count: 1, sides: 20 },
        natural: [{ face: 20, result: 'hit' }, { face: 1, result: 'miss' }],
        critical: { confirm: 'roll_again' },
        minimumDamage: 1,
        defence: LEGACY_DEFENCE_LABEL[defence] ?? defence,
        words: { hit: 'hit', miss: 'miss', critical: 'critical hit', threat: 'threat' },
    };
}
/** An initiative roll's total as stored before issue 1307, when each was named `d20` whatever the dice. */
export const legacyRolledTotal = (stored) => stored.d20;
/** An initiative roll stored without its dice: one d20. */
export const LEGACY_INITIATIVE_DICE = { count: 1, sides: 20 };
/** A sort stored without its rule: highest first, then the higher modifier. */
export const LEGACY_SORT = { order: 'highest', modifier: true };
/** A timed effect stored as `rounds`: rounds of six seconds. */
export const LEGACY_ROUND = { key: 'round', label: 'Round', plural: 'rounds', seconds: 6 };
/** An area stored in feet: five feet a square, every second diagonal counting two; a creature in it when any square of its space is (issue 1128). */
export const LEGACY_AREA = { perSquare: 5, diagonal: 'alternate', includes: 'any_part' };
//# sourceMappingURL=records.js.map